import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function CertificateModal({ cert, onClose }) {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [cert]);

  useEffect(() => {
    if (!cert) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [cert, onClose]);

  if (!cert) {
    return null;
  }

  const showImage = Boolean(cert.image) && !imageFailed;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        aria-labelledby="certificate-modal-title"
        aria-modal="true"
        className="modal-panel"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
      >
        <button
          aria-label="Close"
          className="modal-close"
          onClick={onClose}
          type="button"
        >
          <svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M6 6l12 12M6 18L18 6"/></svg>
        </button>
        {showImage ? (
          <a
            className="modal-image-wrap"
            href={cert.image}
            rel="noreferrer"
            target="_blank"
          >
            <img
              alt={`${cert.title} certificate`}
              className="modal-image"
              onError={() => setImageFailed(true)}
              src={cert.image}
            />
          </a>
        ) : (
          <div className="modal-icon">CERT</div>
        )}
        <h3 className="modal-title" id="certificate-modal-title">
          {cert.title}
        </h3>
        <div className="modal-issuer">{cert.issuer}</div>
        <div className="modal-date">{cert.date}</div>
        {cert.description ? <p className="modal-description">{cert.description}</p> : null}
        {cert.tags && cert.tags.length ? (
          <div className="modal-tags">
            {cert.tags.map((tag) => (
              <span className="modal-tag" key={tag}>
                #{tag.replace(/\s+/g, "")}
              </span>
            ))}
          </div>
        ) : null}
        <div className="modal-actions">
          {cert.slug ? (
            <Link className="btn-primary modal-verify" onClick={onClose} to={`/certificates/${cert.slug}`}>
              View Full Page
            </Link>
          ) : null}
          {cert.credentialUrl ? (
            <a
              className="btn-secondary modal-verify"
              href={cert.credentialUrl}
              rel="noreferrer"
              target="_blank"
            >
              Verify Credential
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default CertificateModal;
